<div>
	<h3>Datos del seguro</h3>

	@for (quote of quoteInfo(); track quote; let i = $index) {
		<div class="flex flex-row justify-between">
			<div class="text-gray-600 text-nowrap">{{ quote[0] }}:</div>
			<div class="text-gray-600 font-semibold text-ellipsis ellipsis">
				{{ quote[1] }}
			</div>
		</div>
	}
</div>
